import { render } from "./MultiselectPersonTag.vue?vue&type=template&id=7724381e&scoped=true"
import script from "./MultiselectPersonTag.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MultiselectPersonTag.vue?vue&type=script&charset=utf-8&lang=js"

import "./MultiselectPersonTag.vue?vue&type=style&index=0&id=7724381e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7724381e"]])

export default __exports__